import tutorial from './docsicon-tutorials.svg';
import tutorials from './docsicon-tutorials.svg';
import guide from './docsicon-guides.svg';
import guides from './docsicon-guides.svg';
import howto from './docsicon-guides.svg';
import pdf from './docsicon-pdf.svg';
import concepts from './docsicon-concepts.svg';
import reference from './docsicon-reference.svg';
import quarkus from './quarkus_icon_default.svg';
import quarkiverse from './quarkiverse_logo_horizontal.svg';
import loading from './loading.svg';

const icons = {
    docs: {
        tutorial,
        tutorials,
        guide,
        guides,
        howto,
        pdf,
        concepts,
        reference
    },
    origins: {
        quarkus,
        quarkiverse
    },
    loading
}

export default icons;
